import React, { useState } from 'react';
import { Colors } from 'library';
import { FieldGroup, Modal, PillButton, Row, Stack, Text, TextArea } from 'library/ui';
import { client } from 'shared';
import { useHistory } from 'react-router';

export default function CancelAllModal({
    open,
    onClose,
    ongoingRequestId,
    providerNames,
    refresh,
}: {
    open: boolean;
    onClose: () => void;
    ongoingRequestId?: number;
    providerNames?: string[];
    refresh: () => void;
}) {
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState<string>('');
    const history = useHistory();

    function submit() {
        setLoading(true);
        client(`api/ongoing/${ongoingRequestId}/cancel/`, {
            method: 'POST',
            body: { comment },
        })
            .then(refresh)
            .finally(() => {
                setLoading(false);
                onClose();
                history.push('/jobs');
            });
    }

    function getMessage() {
        const base =
            'We will cancel all filled and unfilled shifts and will no longer attempt to fill future shifts for this job.';
        if (!providerNames?.length) {
            return base;
        }

        const provider_names = providerNames.join(', ').replace(/, ([^,]*)$/, ' and $1');
        return `${base} This will cancel all upcoming shifts including shifts for ${provider_names}.`;
    }

    if (!open) {
        return null;
    }

    return (
        <Modal title="Cancel this job including all upcoming shifts?" onClose={onClose} width={500}>
            <Stack gap="md">
                <Text tone="secondary">{getMessage()}</Text>
                <FieldGroup label="Reason for cancelling">
                    <TextArea value={comment} onChange={setComment} fullWidth minRows={3} />
                </FieldGroup>
                <Row justify="end" fullWidth>
                    <PillButton color={Colors.error} disabled={loading} onClick={submit}>
                        {loading ? 'Cancelling…' : 'Submit Cancellation'}
                    </PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
